import {DatePicker, DatePickerProps} from "@mui/x-date-pickers";
import {Control, Controller, FieldValues, Path, useFormContext} from "react-hook-form";
import {TextField} from "@mui/material";

type FormDatePickerProps<IFormValues extends FieldValues = FieldValues> = Omit<DatePickerProps<any, any>,
    "renderInput" | "value" | "onChange"> & {
    name: Path<IFormValues>;
    control?: Control<IFormValues, any>;
    label: string;
    readOnly?: boolean;
    required?: boolean;
    handleChange?: Function;
};

const FormDatePicker = <IFormValues extends FieldValues = FieldValues>({
                                                                           name,
                                                                           control,
                                                                           label,
                                                                           readOnly,
                                                                           required,
                                                                           handleChange,
                                                                           ...props
                                                                       }: FormDatePickerProps<any>) => {
    // Use Form Context
    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            render={({field, fieldState}) => (
                <DatePicker
                    {...props}
                    value={field.value}
                    onChange={(value) => {
                        if (handleChange) {
                            handleChange(value);
                        } else {
                            field.onChange(value);
                        }
                    }}
                    disabled={readOnly}
                    inputFormat={"L" || props.inputFormat}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            required={required}
                            label={label}
                            onBlur={field.onBlur}
                            error={Boolean(fieldState.error)}
                            fullWidth
                            helperText={fieldState.error?.message}
                        />
                    )}
                />
            )}
        />
    );
};

export default FormDatePicker;
